import React from "react";
import { ReactComponent as X } from "../../assets/icons/detail-poi-close.svg";

const ModalWifiInformation = ({ onClose }) => {
  // Close modal when clicking outside
  const handleOutsideClick = (e) => {
    if (e.target.id === "modal-overlay") {
      onClose();
    }
  };

  return (
    <div
      id="modal-overlay"
      className="fixed inset-0 z-40 bg-black bg-opacity-50 flex items-center justify-center"
      onClick={handleOutsideClick}
      style={{ margin: 0 }}
    >
      <div className="bg-white absolute w-[90%] md:w-[30%] h-max bg-white overflow-y-auto rounded-2xl shadow-lg m-32">
        <div className="p-4 md:p-8">
          {/* Close Button */}
          <button
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
            onClick={onClose}
          >
            <X size={24} />
          </button>

          {/* Content Section */}
          <div className="flex flex-col pt-4 md:pt-0 md:flex-row gap-4 overflow-y-auto">
            {/* Details */}
            <div className="flex-1 basis-3/4">
              <p className="text-gray-700">
                We're pleased to offer free Wi-Fi for all our guests! To get
                connected, simply head over to the concierge desk, where our
                team will be happy to assist you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWifiInformation;
